// Due-date helpers for Tasks (formerly "Actionables"). Shared by the per-client
// Tasks tab and the portfolio Tasks page so overdue / due-soon emphasis is
// consistent across surfaces.
const DAY_MS = 24 * 60 * 60 * 1000;

export function is_overdue(due) {
    if (!due) return false;
    return new Date(due).getTime() < Date.now();
}

// Due within the next 3 days (and not already overdue).
export function is_due_soon(due) {
    if (!due) return false;
    const t = new Date(due).getTime();
    const now = Date.now();
    return t >= now && t < now + 3 * DAY_MS;
}

// Text color for a due date: red = overdue, amber = due soon, muted otherwise.
export function due_color(due) {
    if (is_overdue(due)) return '#c0392b';
    if (is_due_soon(due)) return '#e67e22';
    return '#7f8c8d';
}
